import * as React from "react";
import "./style.css";
import CarDamageHandler from "../../../departments/CarDamageHandler";
import { addDamage, getLoanCars, removeDamage } from "../../../../state/department/loanCarActions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../../state";
import { RootState } from "../../../../state";
import { getDepartments } from "../../../../state/action";
import { DefaultButton, DialogFooter, PrimaryButton } from "@fluentui/react";

const PDFPATH = "/Låneaftale_Kundebil_El.pdf";

interface Props {
    order: Order;
    onDismiss: () => void;
}

const LoanCarAgreement: React.FunctionComponent<Props> = props => {
    const { order } = props;
    const departments = useSelector((state: RootState) => getDepartments(state));
    const dispatch = useDispatch<AppDispatch>() as any;
    const [loanCar, setLoanCar] = React.useState<LoanCar | undefined>();

    React.useEffect(() => {
        if (props.order.timeAndPlace.department && props.order.timeAndPlace.department.id) {
            dispatch(getLoanCars(props.order.timeAndPlace.department.id));
        }
    }, [props.order.timeAndPlace.department])

    React.useEffect(() => {
        if (props.order.timeAndPlace.department && props.order.timeAndPlace.department.id && props.order.orderProperties && props.order.orderProperties.loanCarId) {
            const department = departments.find(x => order.timeAndPlace.department && x.id === order.timeAndPlace.department.id);
            setLoanCar(department && department.loanCars && department.loanCars.find(x =>props.order.orderProperties && x.id === props.order.orderProperties.loanCarId));
        }
    }, [departments, props.order.timeAndPlace.department])
    const addDamageClick = (type: "Before" | "After") => (damage: CarDamage) => {

        if (props.order.timeAndPlace.department && props.order.timeAndPlace.department.id && loanCar) {
            dispatch(addDamage(props.order.timeAndPlace.department.id, loanCar.id, damage));
        }
    };

    // Remove marker when clicked
    const removeDamageClick = (type: "Before" | "After") => (markerId: string) => {
        if (props.order.timeAndPlace.department && props.order.timeAndPlace.department.id && loanCar) {
            dispatch(removeDamage(props.order.timeAndPlace.department.id, loanCar.id, markerId));
        }
    };

  
    const onSaveClick = async () => props.onDismiss();

    return (<>
        <div className="signature_section">
            <a href={props.order.orderProperties && props.order.orderProperties.signedLoanCar}>Se aftale</a>
            {/* Damage */}
            <div className="box full_width_box">
                <h3>Skader</h3>
                <div className="damage_image_wrapper">
                   
                    <div className="damage_image">
                        <p>Efter udlevering</p>
                        <CarDamageHandler addDamage={addDamageClick("After")} removeDamage={removeDamageClick("After")} damage={loanCar && loanCar.damage} />
                    </div>
                </div>
            </div>
        </div>
           
        <DialogFooter>
            <PrimaryButton onClick={onSaveClick} text="OK" />
            <DefaultButton onClick={props.onDismiss} text="Anuller" />
        </DialogFooter>
    </>
    );
};

export default LoanCarAgreement;

